﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKHeader from '@tk/components/tk.header';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import DIWViewport from '@/basics/diw.viewport';
import DIWSearch from '@/controls/diw.search';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@/controls/diw.form.validator';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import DIWDialog from '@/components/diw.dialog';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import DIWMinibasket from '@/components/diw.minibasket';
import DIWButtonDropdown from '@/controls/diw.button.dropdown';
import DIWRegistration from '@/components/diw.registration';
import DIWLinks from '@/components/diw.links';

import 'flatpickr/dist/flatpickr.min.css';
import '@scss/modules/verification.scss';

export default class Verification extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: DIWViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'diw-search', constructor: DIWSearch },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-dialog', constructor: DIWDialog },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'tk-button-dropdown', constructor: DIWButtonDropdown },
            { name: 'diw-minibasket', constructor: DIWMinibasket },
            { name: 'diw-registration', constructor: DIWRegistration },
            { name: 'diw-links', constructor: DIWLinks },
        ]);
    }
}

new Verification();
